<template>
    <v-sheet class="p-0 py-0 rate-plan-card-border">
        <v-col col="12">
            <div style="line-height: 1 !important;">
                <rate-breakdown :IsPackage="false" :RatePlan="RatePlan">
                    <span class="font-weight-medium text-wrap text-subtitle-1">{{
                        RatePlan.rateName }}</span>
                </rate-breakdown>
                <!-- <span v-if="RatePlan.isIncludeBreakfast">
                    <v-icon small class="green--text darken-2">mdi-silverware-fork-knife</v-icon>
                    <small class="grey--text">
                        Breakfast Included
                    </small>
                </span>
                <span class="green--text darken-2" v-if="RatePlan.isRefundable"><v-badge color="success"
                        content="Refundable" inline></v-badge>
                </span> -->
                <span v-if="IsPackage"> {{ RatePlan.room.roomName }}</span>
            </div>
        </v-col>
        <v-row class="d-flex justify-space-between mb-0">
            <v-col cols="12" lg="4" sm="4" xs="4" md="3" class="d-flex align-center">

                <ul>
                    <!-- <li>
                        <span>
                            <rate-breakdown :IsPackage="false" :RatePlan="RatePlan"><small>More Info</small></rate-breakdown>
                        </span>
                    </li> -->
                    <li v-if="RatePlan.isIncludeBreakfast">
                        <span>
                            <v-icon>mdi-silverware-fork-knife</v-icon>
                            <span>
                                Breakfast Included
                            </span>
                        </span>
                    </li>
                    <li v-if="RatePlan.depositPercentage > 0">
                        <span>
                            <v-icon>mdi-cash-fast</v-icon>
                            <span>
                                Deposit Required
                            </span>
                        </span>
                    </li>
                    <li>
                        <span v-if="RatePlan.isRefundable">
                            <v-icon>mdi-credit-card-refund</v-icon>
                            <span>
                                Refundable
                            </span>
                        </span>
                        <span v-if="!RatePlan.isRefundable">
                            <v-icon>mdi-cancel</v-icon>
                            <span>
                                Non-Refundable
                            </span>
                        </span>
                    </li>
                </ul>
            </v-col>
            <v-col cols="12" xl="8" lg="8" sm="6" xs="8" md="6">
                <v-row class="d-flex justify-end">
                    <v-col cols="12" lg="6" sm="5" xs="4" md="6" class="text-center">
                        <div class="text-h6">
                            {{ RatePlan.displayTotalPrice }}
                        </div>
                        <div class="text-decoration-line-through deep-orange--text"
                            v-if="GetPromoCode() !== '' || RatePlan.hotDealsType === 'PercentDiscount' || RatePlan.hotDealsType === 'AmountDiscount' || RatePlan.hotDealsType === 'FixedAmount'">
                            <small>{{ RatePlan.displayOriginalPrice }}</small>
                        </div>

                        <div>
                            <span class="text--disabled text-body-2">Cost for {{ RatePlan.priceList.length }} night(s),
                                {{ RatePlan.standardGuestIncluded }} guests</span>
                        </div>

                    </v-col>

                    <v-col cols="12" xl="4" lg="4" sm="4" xs="4" md="4" id="rateplanOccupancyOption"
                        class="d-flex align-center">
                        <div class="col-12">
                            <!-- <v-select v-model="selectedUnit" :items="Occupancy" dense solo small-chips> </v-select> -->
                            <v-btn href="#addRoomSection" class="col-12 col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-4"
                                style="color: white !important; font-weight: 600 !important;"
                                v-if="Occupancy.length !== 0 && RatePlan.isValid
                                    && !(RatePlan.maxNights !== 0 && RatePlan.maxNights < RatePlan.priceList.length) && RatePlan.isValidPeriod" color="indigo indigo-lighten-1"
                                @click="reserve"> Book
                            </v-btn>


                            <v-btn class="text-center col-12 col-lg-8 col-md-3 col-sm-4 col-xs-4"
                                v-if="Occupancy.length === 0 && !(RatePlan.maxNights !== 0 && RatePlan.maxNights < RatePlan.priceList.length)"
                                color="deep-purple lighten-2" disabled text>
                                No more rooms
                            </v-btn>

                            <v-btn class="text-center col-12 col-lg-9 col-md-3 col-sm-4 col-xs-4"
                                v-else-if="!RatePlan.isValid && !(RatePlan.maxNights !== 0 && RatePlan.maxNights < RatePlan.priceList.length) && RatePlan.isValidPeriod"
                                color="red darken-1" disabled text>
                                {{ RatePlan.minNights }} min nights
                            </v-btn>

                            <v-btn class="text-center col-12 col-lg-9 col-md-3 col-sm-4 col-xs-4"
                                v-else-if="RatePlan.maxNights !== 0 && RatePlan.maxNights < RatePlan.priceList.length && RatePlan.isValidPeriod"
                                color="red darken-1" disabled text>
                                {{ RatePlan.maxNights }} max nights
                            </v-btn>

                            <v-btn class="text-center col-12 col-lg-8 col-xl-9 col-md-3 col-sm-4 col-xs-4"
                                v-else-if="!RatePlan.isValidPeriod" color="red darken-1" disabled text>
                                <small>
                                    Validity period </br>{{ formatDate(RatePlan.startDate) }} to {{
                                        formatDate(RatePlan.endDate)
                                    }}
                                </small>

                            </v-btn>
                        </div>
                    </v-col>
                </v-row>

            </v-col>

        </v-row>


    </v-sheet>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

import RateBreakdown from './RateBreakdown.vue';

export default {
    components: {
        RateBreakdown
    },
    props: {
        RatePlan: {
            type: Object,
            required: true
        },
        Occupancy: {
            type: Array,
            required: true
        },
        Room: {
            type: Object,
            required: true
        },
        IsPackage: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            selectedUnit: 1
        }
    },
    methods: {
        reserve() {
            // this.RoomRate.occupancy -= this.selectedUnit

            this.$store.dispatch("setSelectedRoomRate", this.RatePlan);
            this.$store.dispatch("setSelectedRoom", this.Room);
            this.selectedUnit = 1;
            this.$store.dispatch('setActiveScreen', 'addRoom');
        },
        formatDate(date) {
            return moment(date).format('DD MMM YY')
        },
    },
    computed: {
        availability: function () {
            if (this.IsPackage) {
                return this.RatePlan.room.availability;
            } else {
                return this.Room.availability;
            }

            return 0;
        },
        ...mapGetters(['GetPromoCode'])
    }
}

</script>


<style>
/* #rateplanOccupancyOption div.v-input__slot {
    margin-bottom: -20px !important;
} */

.rate-plan-card-border {
    /* padding: 16px !important;
    border-radius: 4px !important;
    border: 1px solid #e2e5e9 !important;
    border-top: 0.5px solid #e2e5e9 !important; */
    border-top: thin solid rgba(0, 0, 0, .12) !important;
    background-color: unset !important;
}
</style>